import Picker from './date-picker'

import RangePicker from './range-picker'

export type { PickerProps } from './date-picker'

export type { RangePickerProps } from './range-picker'

export { RangePicker }

export default Picker
